const destinationList = {
  'btc': {
    destination: 'Jamaica',
    img: 'btc',
    subtitle: 'There is a magic to the island of Jamaica',
    description: 'A Caribbean Holiday in true island luxury. <a href="/resorts/turks-caicos/">VIEW RESORT <i class="icon-button-arrow-next"></i></a>',
    name: 'Turks &amp; Caicos',
    location: 'Providenciales, Turks &amp; Caicos'
  },
  'bng': {
    destination: 'Bahamas',
    img: 'bng',
    subtitle: 'Paradise is just minutes away from the U.S. Coastline',
    description: 'There\'s a magic to Jamaica that is as soul-stirring as a sunset and as innocent as a child\'s smile.<a href="/resorts/negril/">VIEW RESORT <i class="icon-button-arrow-next"></i></a>',
    name: 'Negril',
    location: 'Negril, Jamaica'
  },
  'bbo': {
    destination: 'Antigua',
    img: 'bbo',
    subtitle: 'Remarkable Natural Bounty',
    description: 'Jamaicas\' family beachfront getaway, voted among the Top 10 Best Beach Resorts by Parents magazine. <a href="/resorts/ocho-rios/">VIEW RESORT <i class="icon-button-arrow-next"></i></a>',
    name: 'Ocho RIos',
    location: 'Ocho Rios, Jamaica'
  }
};

module.exports = destinationList;
